import { Component, OnDestroy, OnInit } from '@angular/core';
//import {OfficesHeaderComponent} from '../offices-header/offices-header.component'
import {HttpClient} from '@angular/common/http';
import { Subject } from 'rxjs';
import { MasterService } from 'src/app/shared/services/master.service';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { SortBy } from 'src/app/Enums/sortEnums';
import * as _ from "underscore";
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { OfficesService } from 'src/app/shared/services/offices.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { filterData, InwardFilter } from 'src/app/shared/classes/filter';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';
import { ComponentName, ModalSize } from 'src/app/Enums/usersFilterEnums';
import { Office } from 'src/app/shared/classes/users';
import {InwardStatus} from 'src/app/Enums/inwardEnum';
import { InwardService } from 'src/app/shared/services/inward.service';
import { Router } from '@angular/router';
import { ReceivedByComponent } from '../received-by/received-by.component';
import { UploadChallanComponent } from '../upload-challan/upload-challan.component';
import { utils, writeFile } from 'xlsx';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { CollectMaterialComponent } from '../collect-material/collect-material.component';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';
//import { EditOfficeComponent } from '../edit-office/edit-office.component';

@Component({
  selector: 'app-inward-table',
  templateUrl: './inward-table.component.html',
  styleUrls: ['./inward-table.component.less']
})
export class InwardTableComponent implements OnInit, OnDestroy {
    modalRef: BsModalRef;
    tableSetting: any;
    usersList: any;
    userModel: any;
    registrationList: any;
    statusList:any;
    brfromList:any;
    reByList:any;
    totalCount: number;
    // rowsperpage: number = 10;
    currentIndex: number;
    p: number = 1;
    //offset: any;
    errorMessage: string;
    showError: boolean;
    showNoResult: boolean = false;
    displaysort: boolean = false;
    registrationArray: Array<any> = new Array();
    officeArray: Array<any> = new Array();
    statusArray: Array<any> = new Array();
    brfromArray: Array<any> = new Array();
    reByArray: Array<any> = new Array();
    filterData = {} as filterData;
    itemsperPage: number = 10;
    userName: any = '';
    duedatecomparer:string;
    officeID: number;
    officeName:string;
    countLength: number;
    isPaginationChange : boolean = false;
    selectedOffice:any;
    data : any = [];
    status : string = '';
    InwardStatus = InwardStatus;
    regId: number;
    regType: string;
    regDateTimeFrom: any;
    regDateTimeTo: any;
    request: any;
    name: string = '';
    selectedRequest : any;
  private service_URL: any;
  private unsubscribe$ =new Subject<void>();
  
  constructor(
    private httpClient : HttpClient, 
    private _masterService: MasterService,
    private inwardService: InwardService,
    private _dataContextService: DataContextService,
    private modalService: BsModalService,
    private toast: ToastrService,
    private router: Router,private trackeromnitureservice:TrackerOmnitureService
    ) {
        this.filterData.page = 1;
    this.service_URL = ConstantsService;
  }

  ngOnInit(): void {
    this.inwardService.refreshPage
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
        this.isPaginationChange = false;
        this.ResetInwardObjects();
        this.getUsersData();
    });

        this.inwardService.refreshwithFilters
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
            this.isPaginationChange = false;
            this.getUsersData();
        });

        this.inwardService.deleteReg
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          this.DeleteAlert(this.regId,this.regType,this.request);
        });

        this.tableSetting = {
            columns: this.tableSettingColumns()
        };

        //this.getUsers();
        this.getUsersData();
        var username = localStorage.getItem('email');
        username = username.split('@')[0];
        this.trackeromnitureservice.trackPageloadData('inward',username);
        this.trackeromnitureservice.trackPage("pageView");        
       // this.setIntialPageCount();

    this.tableSetting = {
      columns: this.tableSettingColumns()
  };
  }
  
  ResetInwardObjects() {
    InwardFilter.cityList = [];
    InwardFilter.statusList=[];
    InwardFilter.broughtFromList = [];
    InwardFilter.receivedByList = [];
    InwardFilter.regTypeList = [];
    this.userName = '';
    this.filterData.page = 1;
}

  searchOfficeByName(val) {
    // console.log(val);
    this.isPaginationChange = false;
    this.userName = val.username;
    this.regDateTimeFrom = val.fdate;
    this.regDateTimeTo = val.edate;
    this.filterData.page = 1;
    this.getUsersData();
}

PrepareUsersObj() {
  
//   console.log(this.regDateTimeFrom.slice(0,11) + '00:00:00.000Z');
    var ourDate = new Date();
    var pastDate = ourDate.getDate() - 7;
    ourDate.setDate(pastDate);

  let params = {
      RequestType : InwardFilter.regTypeList,
      City: InwardFilter.cityList,
      BroughtFrom : InwardFilter.broughtFromList,
      Status : InwardFilter.statusList,
      ReceivedBy : InwardFilter.receivedByList,
      SearchByName: null,
      DcNumber : this.userName,
      PageNo: this.filterData.page,
      RegistrationDateTimeFrom : this.regDateTimeFrom == undefined ? (ourDate.toISOString()) : (this.regDateTimeFrom.slice(0,11) + '00:00:00.000Z'),
      RegistrationDateTimeTo : this.regDateTimeTo == undefined ? new Date().toISOString() : (this.regDateTimeTo.slice(0,11) + '23:59:00.000Z'),
      LoggedinUserEmail: localStorage.getItem('email'),
      FilterBySupervisorCities: true
  };
//   console.log(params);
  return params;
}

downloadFile(obj: any){
    var base64: string = "";

    var fileName: string = "";
    
    var extension: string = "";

    fileName = obj.challanPath;
    var ext = fileName.split(".");
    extension = ext[1];


    this._dataContextService.get<any>(this.service_URL.ChallanUpload.download + '?reqId=' + obj.requestId)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
        // console.log(res);
        base64 = res.fileBase64;

    },
    (error) => {
        console.log(error);
        this.toast.error("File could not be downloaded");
    },
    () => {
        var a = document.createElement('a');
        if(extension === 'pdf'){
            a.href = "data:application/pdf;base64," + base64;
        }
        else{
            a.href = "data:image/" + extension + ";base64," + base64;
        }
        a.download = fileName;
        a.click();

        this.toast.success("File downloaded");
    })
}

// handleExport() {
//     const headings = [[
//         'requestId',
//         'serialNumber',
//         'type',
//         'createdBy'
//     ]];
//     const wb = utils.book_new();
//     const ws: any = utils.json_to_sheet([]);
//     utils.sheet_add_aoa(ws, headings);
//     utils.sheet_add_json(ws, this.usersList, { origin: 'A2', skipHeader: true });
//     utils.book_append_sheet(wb, ws, 'Report');
//     writeFile(wb, 'Gatepass Report.xlsx');
// }

//get the city list from api
loadCityOptions(citydata: any) {
  this.registrationList = citydata;
  this.registrationArray = citydata;
  if (this.registrationArray) {
      this.registrationArray.forEach(item => {
          item.description = item.name; 
      })
  }
  if (InwardFilter.regTypeList.length == 0) {
      this.registrationArray.forEach(item => {
          item.isCheck = true;
      })
  }
  else {
      this.registrationArray.forEach(item => {
          InwardFilter.regTypeList.forEach(item1 => {
              if (item.description == item1) {
                  item.isCheck = true;
              } 
          })
      })
  }
  this.tableSetting.columns[2].isFilterIcon = true;
}

//get the status list from api
loadStatusOptions(statusdata: any) {
  this.statusList = statusdata;
  this.statusArray = statusdata;
  if (this.statusArray) {
      this.statusArray.forEach(item => {
          item.description = item.name;
      })
  }
  if (InwardFilter.statusList.length == 0) {
      this.statusArray.forEach(item => {
          item.isCheck = true;
      })
  }
  else {
      this.statusArray.forEach(item => {
          InwardFilter.statusList.forEach(item1=>{
              if (item.description == item1) {
                  item.isCheck = true;
              } 
          })
      })
  }
  this.tableSetting.columns[3].isFilterIcon = true;
}

loadBroughtFromOptions(brfromdata : any){
    this.brfromList = brfromdata;
  this.brfromArray = brfromdata;
  if (this.brfromArray) {
      this.brfromArray.forEach(item => {
          item.description = item.name;
      })
  }
  if (InwardFilter.broughtFromList.length == 0) {
      this.brfromArray.forEach(item => {
          item.isCheck = true;
      })
  }
  else {
      this.brfromArray.forEach(item => {
          InwardFilter.broughtFromList.forEach(item1=>{
              if (item.description == item1) {
                  item.isCheck = true;
              } 
          })
      })
  }
  this.tableSetting.columns[4].isFilterIcon = true;
}

loadReceivedByOptions(reBydata : any){
    this.reByList = reBydata;
  this.reByArray = reBydata;
  if (this.reByArray) {
      this.reByArray.forEach(item => {
          item.description = item.name;
      })
  }
  if (InwardFilter.receivedByList.length == 0) {
      this.reByArray.forEach(item => {
          item.isCheck = true;
      })
  }
  else {
      this.reByArray.forEach(item => {
          InwardFilter.receivedByList.forEach(item1=>{
              if (item.description == item1) {
                  item.isCheck = true;
              } 
          })
      })
  }
  this.tableSetting.columns[5].isFilterIcon = true;
}

setIntialPageCount(totalrecords : number)
{
    //this.totalCount = totalCount;
    this.isPaginationChange = true;
    if (totalrecords > this.itemsperPage) {
        this.countLength = this.itemsperPage;
    }
    else {
        this.countLength = totalrecords;
    }
}

deleteReg(requestId: number,returnType: string, request: any) {
    // console.log(requestId)
    // console.log(returnType)

    this.regId = requestId;
    this.regType = returnType;
    this.request = request;
    // this.officeID = selectedOfficeID;
    // this.selectedOffice=office;
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
   
// const modalsmWidth = ModalSize.Small;
    this.modalRef.setClass(ModalSize.Small);
    this.modalRef.content.title = 'Delete Registration';
    this.modalRef.content.description = 'Are you sure you want to delete <b>' + returnType + ' registration </b>?';
    this.modalRef.content.buttonsTitle = {
        dismiss: 'Cancel',
        confirm: 'Delete',
        component: ComponentName.Inward
    }
}

getUsersData() {
    let data = this.PrepareUsersObj();

    this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.GetInwardRequestsByFilter, data)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
        // console.log(res);
        this.userModel = res;
        this.usersList = res.gatepassInwardrequests;
        this.duedatecomparer=new Date().toISOString();
        this.usersList.forEach(element => {
       
          const dueDate = new Date(this.duedatecomparer);
          const returnDate = new Date(element.returnDateTime);
  
          const timeDifference = dueDate.getTime() - returnDate.getTime();
  
          const daysDifference = timeDifference / (1000 * 3600 * 24);
          const hoursDifference = Math.abs(timeDifference / (1000 * 3600));
          const days = Math.abs(Math.round(daysDifference));
          
          if (days === 1 || days === 2 || hoursDifference <= 48) {
              element.duedatebeforetwodays = true;
          } else {
              element.duedatebeforetwodays = false;
          }
      
      });
        //this.filterData.page = 1;
        //this.rowsperpage =3;
        this.totalCount = res.totalRecords;
        
        this.loadCityOptions(res.type);
        this.loadStatusOptions(res.status); 
        this.loadBroughtFromOptions(res.broughtFrom);
        this.loadReceivedByOptions(res.receivedBy);
        if(!this.isPaginationChange)
        {
            this.setIntialPageCount(this.totalCount);
        }

    })

    // this._dataContextService.get<any>(this.service_URL.InwardDetails.GetInwardRequests)
    // .pipe(takeUntil(this.unsubscribe$))
    // .subscribe(res => {userList
    //     console.log(res);
    //     this.userModel = res;
    //     this.usersList = res;
    // })
}
CheckMaterials(id,serialNumber){
    let params = {
      statusId : InwardStatus.Checked,
      requestId : id,
      updatedBy : localStorage.getItem('email')
    }

    let auditData = [];

    let statusChangeAudit: AuditData = new AuditData();
    statusChangeAudit.changedAttribute = "Status";
    statusChangeAudit.oldValue = null;
    statusChangeAudit.newValue = "Check Materials"

    auditData.push(statusChangeAudit);
    
    this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateStatus,params)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      if(res == 1){
        this.toast.success("Materials Successfully Checked");
      }
      else{
        this.toast.error("Something went wrong");
      }
    },
    (err) => {
        console.log(err);
    },
    () => {
        //Saving Data in Audit Trail
      let auditParams = {
        actionPerformed : "Status Change",
        actionPerformedOn : "Inward",
        changedBy : localStorage.getItem('email'),
        dateChanged : new Date(),
        primaryKey : serialNumber,
        generalInformation : [],
        material : [],
        statusChange: auditData
      };

      this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail,auditParams)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        // console.log(res);
      },
      (err) => {
        console.log(err);
      },
      () => {
        window.location.reload();
      })
    })
}

CollectMaterials(selectedRequest:any){
    this.modalRef = this.modalService.show(CollectMaterialComponent,{
        initialState : {
            selectedRequest : selectedRequest
        }
      })
      this.modalRef.setClass(ModalSize.Large);
      this.modalRef.content.event.subscribe(res => {
        console.log(res);
      });
}

UploadChallan(selectedRequest : any){
    // let params = {
    //   statusId : InwardStatus.ChallanUploaded,
    //   requestId : this.viewData.requestId
    // }

    // this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateStatus,params)
    // .pipe(takeUntil(this.unsubscribe$))
    // .subscribe((res) => {
    //   if(res == 1){
    //     this.toast.success("Materials Successfully Checked");
    //     this.GetById(this.id);
    //     window.location.reload();
    //   }
    //   else{
    //     this.toast.error("Something went wrong");
    //   }
    // })

    this.modalRef = this.modalService.show(UploadChallanComponent,{
      initialState : {
        selectedRequest : selectedRequest
      }
    })
    this.modalRef.setClass(ModalSize.Large);
    this.modalRef.content.event.subscribe(res => {
      console.log(res);
    });

  }

  ReceivedBy(selectedRequest : any){
//     this.modalRef = this.modalService.show(ReceivedByComponent,{
//       initialState : {
//         selectedRequest : selectedRequest
//       }
//     })
//     this.modalRef.setClass(ModalSize.Large);
//     this.modalRef.content.event.subscribe(res => {
   this.GetById(selectedRequest.requestId);
  }

  GetById(id){
    this._dataContextService.get<any>(this.service_URL.InwardDetails.ViewRequest + '/' + id)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      // console.log(res);
      this.selectedRequest = res;
      this.Submit();
      },
      (error) => {
        console.log(error);
        this.toast.error("Something not working");
      },
      () => {
        // console.log(this.selectedRequest);
      }
    )
  }

UpdateStatus(){
    let params = {
      statusId : InwardStatus.Received,
      requestId : this.selectedRequest.requestId,
      updatedBy: localStorage.getItem('email'),
      CollectedBy: this.selectedRequest.collectedBy,
      CollectedByName: this.selectedRequest.collectedByName
    }

    let auditData = [];

    let statusChangeAudit: AuditData = new AuditData();
    statusChangeAudit.changedAttribute = "Status";
    statusChangeAudit.oldValue = "Challan Uploaded";
    statusChangeAudit.newValue = "Received";

    auditData.push(statusChangeAudit);
    
    this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateStatus,params)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      if(res == 1){
        // this.modalService.hide(1);
      }
      else{
        this.toast.error("Something went wrong");
      }
    },
    (error)=>{
      this.toast.error("Status cannot be updated");
    },
    () => {
      //Saving Data in Audit Trail
      let auditParams = {
        actionPerformed : "Status Change",
        actionPerformedOn : "Inward",
        changedBy : localStorage.getItem('email'),
        dateChanged : new Date(),
        primaryKey : this.selectedRequest.serialNumber,
        generalInformation : [],
        material : [],
        statusChange: auditData
      };

        this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail,auditParams)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          // console.log(res);
        },
        (err) => {
          console.log(err);
        },
        () => {
          //window.location.reload();
        })
    })
  }

  Submit(){

    let PrepareObj = {
      RequestId: this.selectedRequest.requestId,
      DCNumber : this.selectedRequest.dcNumber,
      RegistrationDateTime : this.selectedRequest.registrationDateTime,
      ReturnDateTime : this.selectedRequest.returnDateTime,
      Remarks : this.selectedRequest.remarks,
      // BroughtFromId : this.selectedOption === undefined ? 0 : this.selectedOption.broughtFromId,
      BroughtFromId : parseInt(this.selectedRequest.broughtFrom),
      ReceivedById : parseInt(this.selectedRequest.receivedBy),
      // BroughtFromName : this.selectedOption === undefined ? this.nameNotInList : this.selectedOption.name,
      // BroughtFrom : this.selectedOption === undefined ? this.nameNotInList : this.selectedOption.name,
      BroughtFromName : this.selectedRequest.broughtFromName,
      BroughtFrom : this.selectedRequest.broughtFromName,
      ReceivedBy : this.name.toUpperCase(),
      ReceivedByName : this.name.toUpperCase(),
      ReceivedOn : new Date().toISOString(),
      RegistrationType : this.selectedRequest.registrationType,
      RecipientName : this.selectedRequest.recipientName,
      RecipientEmailId : this.selectedRequest.recipientEmailId,
      IsActive : this.selectedRequest.isActive,
      StatusId : this.selectedRequest.statusId,
      CreatedBy: this.selectedRequest.createdBy,
      cityId: this.selectedRequest.cityId,
      cityName: this.selectedRequest.cityName,
      officeId: this.selectedRequest.officeId,
      CollectedBy: this.selectedRequest.collectedBy,
      CollectedByName: this.selectedRequest.collectedByName,
      officeName: this.selectedRequest.officeName,
      UpdatedBy: localStorage.getItem('email'),
      materialList : this.selectedRequest.materialList,
      attachedFiles:[]
    }

    // console.log(PrepareObj);
    
    // let params = {
    //     receivedById: this.selectedRequest.receivedById,
    //     receivedByName: this.name.toUpperCase(),
    //     updatedBy: localStorage.getItem('email')
    // };

    this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateInwardRequest, PrepareObj)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      if(res == 1){
        this.UpdateStatus();
        //this.toast.success("Updated Received By");
      }
      else{
        this.toast.error("Something went wrong");
      }
    },
    (error)=>{
      this.toast.error("Received By cannot be updated");
    },
    () => {
      this.toast.success("Status Changed to Recieved");
      window.location.reload();
    }) 
    
    
}
  
changeStatus(id){
    if(id == InwardStatus.Created){
        this.status = 'Created';
        return 'Created';
    }
    else if(id == InwardStatus.Checked){
        this.status = 'Checked';
        return 'Checked';
    }
    else if(id == InwardStatus.Collected){
        this.status = 'Collected';
        return 'Collected';
    }
    else if(id == InwardStatus.ChallanUploaded){
        this.status = 'Challan Uploaded';
        return 'Challan Uploaded';
    }
    else if(id == InwardStatus.Declined){
        this.status = 'Declined';
        return 'Declined';
    }
    else if(InwardStatus.Received){
        this.status = 'Transaction Complete';
        return 'Transaction Complete';
    }
    else{
        return '-';
    }
}
checkFilterApplied(val) {
  this.isPaginationChange = false;
  if (val) {
      this.filterData.sortBy = InwardFilter.sortBy;
      this.filterData.sortOrder = InwardFilter.sortOrder;
      this.filterData.page = 1;
      this.p = 1;
      this.checkFilterValue();
      this.getUsersData();
  } else {
      this.usersList = [];
  }
}

checkFilterValue() {
  this.tableSetting.columns.forEach(item => {
      if (InwardFilter.sortBy != item.sortBy) {
          item.isFilterApplied = false;
      }
  })
}
changeCurrentPage(event) {
  //this.isPaginationChange = true;
  this.filterData.page = event.page;
  if ((this.totalCount / (this.filterData.page * this.itemsperPage) > 1)) {
      this.countLength = this.filterData.page * this.itemsperPage
  }
  else {
      this.countLength = this.totalCount;
  }
  this.getUsersData();
}

  showSortingPopup(obj) {

    _.each(this.tableSetting.columns, function (item) {
        if (item.Id != obj.Id) {
            item.displaysort = false;
        }
    })
    obj.displaysort = !obj.displaysort;
}

// showEditData(selectedOfficeRow: any) {
//     console.log(selectedOfficeRow);
    
//     this.modalRef = this.modalService.show(EditOfficeComponent, {
//         initialState: {
//             selectedOffice: selectedOfficeRow,
//         },
//     });        
//     this.modalRef.setClass(ModalSize.Large);
// }

hideDropdowns() {
  _.each(this.tableSetting.columns, function (item) {
      item.displaysort = false;
  })
}

closeDropDown() {
  _.each(this.usersList, function (item) {
      item.showAssigneeDropdown = false;
      item.showStatusDropdown = false;
  })

}

  tableSettingColumns() {
    return [
        
        {
            Id: 1,
            title: "S.No.",
            classes: "ui_size_md",
            isSortable: true,
            isResNameSortN: true,
            sortBy: SortBy.City,
            cityDropdown: true,
            isFilterApplied: false,
            displaysort: false,
            //isOnlyFilter: true,
            isFilterIcon: false
        },
        {
            Id: 2,
            title: "DC No/Tax invoice",
            classes: "ui_size_md",
            //isResNameSortN: true,
            sortBy: SortBy.Phone,
            isFilterApplied: false,
            displaysort: false,
            isFilterIcon: false
        },
        {
          Id:3,
          title: "Type",
          classes: "ui_size_md_small",            
          isSortable: true,
          regDropdown: true,
          //isResNameSortN: true,
          //filterWrapper: "event-type-dropdown",
          sortBy: SortBy.Reg,
          isFilterApplied: false,
          displaysort: false,
          isOnlyFilter: true,
          isFilterIcon: true
      },
      {
          Id:4,
          title: "Status",
          classes: "ui_size_md_small",            
          isSortable: true,
          statusDropdown: true,
          //isResNameSortN: true,
          //filterWrapper: "event-type-dropdown",
          sortBy: SortBy.Status,
          isFilterApplied: false,
          displaysort: false,
          isOnlyFilter: true,
          isFilterIcon: true
      },
      {
          Id: 5,
          title: "Brought from",
          classes: "ui_size_md_small",            
          isSortable: true,
          brfromDropdown: true,
          //isResNameSortN: true,
          //filterWrapper: "event-type-dropdown",
          sortBy: SortBy.BroughtFrom,
          isFilterApplied: false,
          displaysort: false,
          isOnlyFilter: true,
          isFilterIcon: true
      },
      {
        Id: 6,
        title: "Recipient Name",
        //classes: "ui_size_md_small",
        //isResNameSortN: true,
        isFilterApplied: false,
        displaysort: false,
        isFilterIcon: false
    },
    {
        Id: 7,
        title: "Collected Name",
        //classes: "ui_size_md_small",
        //isResNameSortN: true,
        isFilterApplied: false,
        displaysort: false,
        isFilterIcon: false
    },
     /* {
          Id: 6,
          title: "Received By",
          classes: "ui_size_md_small",
          isSortable: true,
          reByDropdown: true,
          //isResNameSortN: true,
          //filterWrapper: "event-type-dropdown",
          sortBy: SortBy.ReceivedBy,
          isFilterApplied: false,
          displaysort: false,
          isOnlyFilter: true,
          isFilterIcon: true
      },*/
      {
          Id: 8,
          title: "Registration Date & Time",
          classes: "ui_size_md",
          //isResNameSortN: true,
          isFilterApplied: false,
          displaysort: false,
          isFilterIcon: false
      },
      {
          Id: 9,
          title: "Return Date & Time",
          classes: "ui_size_md",
          //isResNameSortN: true,
          isFilterApplied: false,
          displaysort: false,
          isFilterIcon: false
      }
    ];
}

viewInwardReg(requestId){
    this.router.navigate(['Inward/ViewInwardReq',requestId]);
}

viewNewReg(){
    this.router.navigate(['Inward/InwardNewReg'])
}

DeleteAlert(selectedReqID: number, office:any, request: any) {
    if(request.isActive == false){
        this.toast.error("Request was already deleted");
        return ;
    }
    let url = this.service_URL.InwardDetails.DeleteRequest + '/' + selectedReqID;       
    // let data = {
    //   id: selectedOfficeID
    // };
        this._dataContextService.postDatawithValuesForDel<any>(url)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(res => {
            // console.log(res);
            if (res=="3") {                
                //ToastrComponent.success("Successfully deleted!");                
                this.toast.error("This Request refered in user");
                
            }
            else if(res=="1"){
                this.toast.error("Request was deleted");
                //this.isPaginationChange = false;
                this.getUsersData();
            }
            else{
                this.toast.error("Some thing went on wrong..")
            }
            
        })
    }

EditRequest(id: number){
    this.router.navigate(['Inward/EditInwardReq',id]);
}


ngOnDestroy(){
  this.unsubscribe$.next();
  this.unsubscribe$.complete();
}
}
